import React from 'react';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import MenuItem from '@mui/material/MenuItem';
import { useState, useEffect} from 'react';
import DocumentLogs from './DocumentLogs';
import { HOST } from '../components/config';

function ReviewDocumentLogs(props) { 
  const [didInitialLoad, setDidIntialLoad]  = useState(false)
  const [assemblyCaseDocumentTransformers, setAssemblyCaseDocumentTransformers] = useState({});
  const [assemblyCaseDocumentProcessingInfo, setAssemblyCaseDocumentProcessingInfo] = useState({});

  const fetchAssemblyCaseDocumentTransformerAndResults = async (assembly_case_document_id, assembly_document_id) => {
      try {
        if (assemblyCaseDocumentTransformers[assembly_case_document_id])
          return
        const response = await fetch(HOST + '/api/assembly_transformers?assembly_document_id=' + assembly_document_id + '&case_id=' + props.info.case_id, {
          "headers" : { 
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
            },  
        });
        const json = await response.json()
        setAssemblyCaseDocumentTransformers((prevState) => ({
          ...prevState,
          [assembly_case_document_id]: json 
        }))
        json.map((item) => fetchAssemblyCaseDocumentTransformerResults(assembly_case_document_id, item.id, item.label) )
      } catch (err) {
      }   
  }
  
  const fetchAssemblyCaseDocumentTransformerResults = async (assembly_case_document_id, assembly_transformer_id, label) => {
      try {
        const response = await fetch(HOST + '/api/assembly_transformer_results?assembly_case_document_id=' + assembly_case_document_id  + '&assembly_transformer_id=' + assembly_transformer_id, {
          "headers" : { 
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': 'Bearer ' + localStorage.getItem('token')
            },  
        });
        const json = await response.json()
        setAssemblyCaseDocumentProcessingInfo((prevState) => {
          var result = {'transformer_id': assembly_transformer_id, 'label': label, 'count_processed': 0, 'count_errored': 0, 'count_processing': 0, 'count_success': 0, 'total': 0, 'updated_at': null }
          json.map((item) => {
            if (item.status.includes('ERROR'))
              result['count_errored'] += 1
            else if (item.status == 'SUCCESS')
              result['count_success'] += 1
            else if (item.status == 'PROCESSING')
              result['count_processing'] +=1
            if (item.updated_at && (!result['updated_at'] || item.updated_at > result['updated_at']))
              result.updated_at = item.updated_at
            result['total'] += 1
          })
          const newEntry = result 
          return ({
          ...prevState,
          [[assembly_case_document_id, assembly_transformer_id]]: newEntry 
        })})
      } catch (err) {
      }   
  }
  
  useEffect( () => {
    // FIX HERE
    setAssemblyCaseDocumentTransformers({})
    setAssemblyCaseDocumentProcessingInfo({})
    fetchAssemblyCaseDocumentTransformerAndResults(props.info.id, props.info.assembly_document_id)
  }, [props.info.id, props.info.assembly_document_id])

  useEffect( () => {
    const intervalId = setInterval(() => { 
    fetchAssemblyCaseDocumentTransformerAndResults(props.info.id, props.info.assembly_document_id)
      
      }, 5000); // Poll every 5 seconds
    
    return () => {
      clearInterval(intervalId); // Clear interval on unmount
    };
  }, [])
  
  useEffect( () => {
    setDidIntialLoad(true)
  }, [])
  console.log(assemblyCaseDocumentTransformers)  
  console.log('above')
  console.log(props.info.id)
  console.log(assemblyCaseDocumentProcessingInfo)  
  return (<>
    <DocumentLogs
      showOutput={false} 
      setPreviewDocumentId={props.setPreviewDocumentId}
      transformers={assemblyCaseDocumentTransformers[props.info.id] || []} 
      results={(assemblyCaseDocumentTransformers[props.info.id] || []).map((item) => assemblyCaseDocumentProcessingInfo[[props.info.id, item.id]]).filter((x) => x)}
      onCancel={() => console.log('cancel')} 
      assemblyCaseDocumentInfo={props.info}
    />
    <Box sx={{ p: 2 }}>
      <Button
        variant='outlined'
        fullWidth
        onClick={() => props.handleDelete() }
        color="error" 
      >Delete Document</Button>
    </Box>
  </>)
}
export default ReviewDocumentLogs;
